import clsx from "clsx";

export function ReplyMailIcon({ className }: { className?: string }) {
  return (
    <span
      className={clsx("inline-flex shrink-0 text-label-secondary", className)}
      title="Antwort per Mail gesendet"
      aria-label="Antwort per Mail gesendet"
    >
      <svg viewBox="0 0 16 16" className="h-3.5 w-3.5" fill="none" aria-hidden>
        <rect x="1.4" y="3.6" width="13.2" height="8.8" rx="1.3" stroke="currentColor" strokeWidth="1.3" />
        <path
          d="M2 4.4 8 8.3 14 4.4"
          stroke="currentColor"
          strokeWidth="1.3"
          strokeLinejoin="round"
        />
        <path
          d="M3.4 13.6H7a2.6 2.6 0 0 0 2.6-2.6"
          stroke="currentColor"
          strokeWidth="1.3"
          strokeLinecap="round"
        />
        <path
          d="M5.2 11.8 3.2 13.6l2 1.8"
          stroke="currentColor"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}

export function IncomingReplyDot({ className }: { className?: string }) {
  return (
    <span
      className={clsx("h-2 w-2 shrink-0 rounded-full bg-status-red", className)}
      title="Neue Antwort auf deine Nachricht"
      aria-label="Neue Antwort auf deine Nachricht"
    />
  );
}

export function ReporterReplyBadge() {
  return (
    <span className="inline-flex items-center rounded-full bg-status-orange px-1.5 py-0.5 text-[10px] font-bold uppercase text-white">
      Antwort
    </span>
  );
}

export function StatusBadge({ status, label }: { status: string; label: string }) {
  const cls =
    status === "open"
      ? "bg-accent/15 text-accent"
      : status === "in_progress"
        ? "bg-status-blue/15 text-status-blue"
        : status === "waiting"
          ? "bg-status-orange/15 text-status-orange"
          : status === "resolved"
            ? "bg-status-green/15 text-status-green"
            : "bg-fill-tertiary text-label-secondary";
  return (
    <span className={clsx("inline-flex rounded-full px-2.5 py-0.5 text-[11px] font-semibold", cls)}>
      {label}
    </span>
  );
}

export function UrgencyBadge({ urgency, label }: { urgency: string; label: string }) {
  const cls =
    urgency === "critical"
      ? "bg-status-red/15 text-status-red"
      : urgency === "high"
        ? "bg-status-orange/15 text-status-orange"
        : urgency === "low"
          ? "bg-status-blue/15 text-status-blue"
          : "bg-fill-tertiary text-label-secondary";
  return (
    <span className={clsx("inline-flex rounded-full px-2.5 py-0.5 text-[11px] font-semibold", cls)}>
      {label}
    </span>
  );
}
